import React from "react";
import PREGUNTAS from "../datos/preguntasFrecuentes.json";
import "../preguntasFrecuentes.css";

// Selectores para useAnimacionesAlScroll de la página que use la sección
export const ANIMACIONES_FAQ = [
  { selector: ".faq-cabecera > *", tipo: "izq", escalonar: true },
  { selector: ".faq-lista details", tipo: "subir", escalonar: true },
];

// Preguntas frecuentes (en /promocion y en el inicio). Las mismas preguntas van como datos estructurados FAQPage
// en el HTML pre-renderizado (ver scripts/prerender.js), así que se editan solo en datos/preguntasFrecuentes.json.
// Con <details> las respuestas quedan en el HTML aunque estén cerradas
export const PreguntasFrecuentes = () => (
  <section className="faq" id="preguntas-frecuentes" aria-labelledby="faq-titulo">
    <div className="faq-cabecera">
      <span className="faq-barra"></span>
      <h2 id="faq-titulo">Preguntas frecuentes</h2>
      <p>{PREGUNTAS[0].respuesta}</p>
    </div>

    <div className="faq-lista">
      {PREGUNTAS.slice(1).map(({ pregunta, respuesta }) => (
        <details key={pregunta}>
          <summary>
            <h3>{pregunta}</h3>
          </summary>
          <p>{respuesta}</p>
        </details>
      ))}
    </div>
  </section>
);
